<template>
<div>
    <headerNav title="返利小金库" />
    <van-calendar v-model="show" :min-date="minDate" type="range" @confirm="onConfirm" />
    <van-sticky>
        <van-cell title="选择订单时间" :value="date" @click="show = true" />
        <div class="pmain" :style="{color:$abctheme.basefzcolor}">
            <div class="pprice">
                <span class="fl">￥</span>
                <span class="fr">{{this.abp.userInfo.privateCoffer}}</span>
            </div>
            <div class="ffbtns">
                <van-button :color="$abctheme.basecolor" round @click="showwithdrawDialog(3)">提现</van-button>
                <van-button :color="$abctheme.basecolor" round @click="showwithdrawDialog(4)">转余额</van-button>
            </div>
        </div>
    </van-sticky>
    <div>
        <van-tabs v-model="tabCurrentIndex" @change="tabchange" sticky offset-top="44">
            <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
            <van-tab :title="navitem.text" v-for="(navitem,navindex) in navList" :key="navindex">
                <van-list v-model="navitem.loaded" :finished="navitem.loadingType=='nomore'?true:false" :finished-text="navitem.loadingType=='nomore'?'没有更多了':'下拉加载更多'" @load="loadData">
                    <div v-for="(item,index) in navitem.List" class="mian-list" @click="detail(item)" :key="index">
                        <div class="mian-list-info">
                            <div class="mian-list-info-data">
                                <div class="zw"></div>
                                <!-- <span>{{item.tid}}</span> -->
                                <van-tag type="primary" class="mian-list-info-right-tag" v-if="item.status==0" size="medium">已到账</van-tag>
                                <van-tag type="danger" class="mian-list-info-right-tag" v-if="item.status==1" size="medium">未到账</van-tag>
                                <van-tag type="danger" class="mian-list-info-right-tag" v-if="item.status==2" size="medium">已取消</van-tag>
                            </div>
                            <div class="mian-list-info-data" v-if="item.sendMethod==1">
                                <span>奖励发放方：</span>
                                <span>{{ item.sendMethod==0?'公司':'上级发放' }}</span>
                            </div>
                            <div class="mian-list-info-data" v-if="item.dealerPrivateCofferType==0||item.dealerPrivateCofferType==4||item.dealerPrivateCofferType==6">
                                <span>下单人：{{item.fromDealerName}}</span>
                            </div>
                            <div class="mian-list-info-data" v-if="item.dealerPrivateCofferType!=5">
                                <span>订单号：{{item.tid}}</span>
                            </div>
                            <div class="mian-list-info-data" v-if="item.dealerPrivateCofferType==0||item.dealerPrivateCofferType==4||item.dealerPrivateCofferType==6">
                                <span>购买商品：{{item.tradeDetailStr}}</span>
                            </div>
                            <div class="mian-list-info-data">
                                <span>返利金额：{{item.costMoney}}</span>
                            </div>
                             <div class="mian-list-info-data">
                                <span>返利类型：{{item.dealerPrivateCofferTypeName}}</span>
                            </div>
                            <div class="mian-list-info-data-last">
                                {{item.creationTime}}
                            </div>
                        </div>

                        <div class="mian-list-mark" v-if="item.status==2&&(item.dealerPrivateCofferType==0||item.dealerPrivateCofferType==4||item.dealerPrivateCofferType==6)">
                            <div>备注:下级代理已退款</div>
                        </div>
                         <div class="mian-list-mark" v-if="item.status!=2&&(item.dealerPrivateCofferType==1||item.dealerPrivateCofferType==2||item.dealerPrivateCofferType==3)">
                            <div>备注:{{item.comment}}</div>
                        </div>
                        <div class="mian-list-mark" v-if="item.status!=2&&(item.dealerPrivateCofferType==0||item.dealerPrivateCofferType==4||item.dealerPrivateCofferType==6)">
                            <div>备注:无</div>
                        </div> 
                        <div class="mian-list-mark" v-if="item.comment&&item.dealerPrivateCofferType==5">
                            <div>备注:{{item.comment}}</div>
                        </div>
                    </div>
                </van-list>
            </van-tab>
            <!-- </van-pull-refresh> -->
        </van-tabs>
    </div>
    <van-dialog v-model="showwithdraw" :title="showwithdrawTitle" show-cancel-button @confirm="withdraw">
       <van-field v-model="money"  label="金额" input-align="right" />
       <van-radio-group v-model="method" v-if="withdrawtype==4">
        <van-cell-group>
          <van-cell title="转大货货款" clickable @click="method = '0'">
            <template #right-icon>
              <van-radio name="0" />
            </template>
          </van-cell>
          <van-cell title="转物料货款" clickable @click="method = '1'">
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
</div>
</template>

<script>
export default {
    data() {
        return {
            date: "",
            sticky: true,
            popshow: false,
            show: false,
            minDate: new Date(2020, 0, 1),
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            fileList: [],
            pageParams: {
                maxResultCount: 8,
                skipCount: 0,
            },
            totalCount: 0,
            tabCurrentIndex: 0,
            navList: [{
                    state: 0,
                    text: '已到账',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        status: [0],
                        sorting: "",
                        maxResultCount: 10,
                        skipCount: 0
                    },
                    List: []
                },
                {
                    state: 1,
                    text: '未到账',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        status: [1],
                        sorting: "",
                        maxResultCount: 10,
                        skipCount: 0
                    },
                    List: []
                },
                {
                    state: 2,
                    text: '已取消',
                    loadingType: 'more',
                    loaded: false,
                    getparams: {
                        status: [2],
                        sorting: "",
                        maxResultCount: 10,
                        skipCount: 0
                    },
                    List: []
                }
            ],
            starttime: undefined,
            endtime: undefined,
            iptvalue: undefined,
            showwithdraw: false,
            showwithdrawTitle: '提现金额',
            withdrawtype: 0,
            money: '',
            method:'0'
        };
    },
    created() {

    },
    methods: {
        formatDate(date) {
            return `${date.getMonth() + 1}/${date.getDate()}`;
        },
        onclose() {
            this.sticky = true;
        },
        onConfirm(date) {
            this.sticky = false;
            const [start, end] = date;
            this.show = false;
            this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;

            this.starttime = start;
            this.endtime = end;
            this.navList.forEach(x => {
                x.loadingType = "refresh";
            });
            this.loadData();
            //将数组重置 并重新执行查询

            //startTime
            //endTime
        },
        onSearch(val) {
            //将数组重置 并重新执行查询
            console.log(val);
            this.iptvalue = val;
            this.navList.forEach(x => {
                x.loadingType = "refresh";
            });
            this.loadData();
        },
        tabchange() {
            this.loadData('tabChange');
        },
        onRefresh() {
            this.loadData('refresh');
        },
        loadData(source) {

            let index = this.tabCurrentIndex;
            let navItem = this.navList[index];
            // let state = navItem.state;

            if (source === 'tabChange' && navItem.loaded === true) {
                //tab切换只有第一次需要加载数据
                return;
            }

            if (navItem.loadingType === 'loading' || navItem.loadingType === 'nomore') {
                //防止重复加载
                if (source != 'refresh') {
                    return;
                }
            }

            if (source == 'refresh' || navItem.loadingType == 'refresh') {
                this.navList[index].List = [];
                this.navList[index].getparams.skipCount = 0;
                this.navList[index].getparams.startTime = this.starttime;
                this.navList[index].getparams.endtime = this.endtime;
            }

            navItem.loadingType = 'loading';
            var params = navItem.getparams;
            //加载数据
            this.ajax.post('/api/services/app/PhoneUser/QueryPrivateCofferPages', params).then(x => {
                this.navList[index].getparams.skipCount += this.navList[index].getparams.maxResultCount;
                let totalcount = x.result.totalCount;
                this.navList[index].List = this.navList[index].List.concat(x.result.items);
                //console.log(this.navList);
                // item = Object.assign(item, this.orderStateExp(item.state));
                this.navList[index].loadingType = totalcount > (this.navList[index].getparams.skipCount) ? 'more' : 'nomore';
            }).finally(() => {
                this.$set(this.navList[index], 'loaded', false);
                this.refreshing = false;
            });

        },
        showwithdrawDialog(e) {
            this.showwithdrawTitle = "";
            this.withdrawtype = e;
            if (e == 1 || e == 3) {
                if (!this.abp.userInfo.wxPramOpenId) {
          this.$dialog.confirm({
            title:'未绑定微信,无法申请提现',
            message:'点击确定前往微信绑定!'
          })
          .then(()=>{
            this.$router.push({
              name:'set'
            })
          })
          return;
        }
                this.showwithdrawTitle = "提现申请"
            }
            if (e == 2 || e == 4) {
                this.showwithdrawTitle = "转货款申请"
            }
            this.showwithdraw = true
        },
        withdraw() {
            if(!this.money){
this.$dialog.alert({message:'请输入正确的金额'});
return;
      }
            if (this.withdrawtype == 3) {
                this.ajax.post('/api/services/app/PhoneWallet/ApplyPrivateCofferAccessoriesLoansWithdraw?money=' + this.money).then(x => {
                    this.$toast.success('申请成功');
                })
            }
            if (this.withdrawtype == 4) {
                this.ajax.post('/api/services/app/PhoneWallet/PrivateCofferToAccessoriesLoans?money=' +
                    this.money+'&method='+this.method).then(x => {
                    this.$toast.success('申请成功');
                })
            }
        }
        // onLoad() {
        //   if (this.refreshing) {
        //     this.list = [];
        //     this.refreshing = false;
        //     this.pageParams.skipCount = 0;
        //   }
        //   this.ajax
        //     .post(
        //       "/api/services/app/PhoneUser/QuerySubRechargeRecordPages",
        //       this.pageParams
        //     )
        //     .then((x) => {
        //       const items = x.result.items;
        //       this.list.push(...x.result.items);
        //       this.pageParams.skipCount += this.pageParams.maxResultCount;
        //       this.totalCount = x.result.totalCount;
        //     })
        //     .finally(() => {
        //       this.loading = false;

        //       if (this.pageParams.skipCount >= this.totalCount) {
        //         this.finished = true;
        //       }
        //     });
        // },
        // onRefresh() {
        //   // 清空列表数据
        //   this.finished = false;

        //   // 重新加载数据
        //   // 将 loading 设置为 true，表示处于加载状态
        //   this.loading = true;
        //   this.onLoad();
        // },
    },
};
</script>

<style lang="scss" scoped>
.mian-list {
    background-color: #fff;
    margin-top: 10px;
    font-size: 12px;
    border-radius: 8px;
    margin: 10px;
    padding: 10px;
    box-shadow: 1px 1px 4px #c3c3c3;
    word-break: break-all;
    line-height: 20px;
}

.mian-list-info {
    padding: 5px 0 5px 0px;
    font-size: 14px;
    position: relative;
    word-break: break-all;
}

.mian-list-info-right {
    position: absolute;
    right: 0;
    width: 90px;
    text-align: right;
}

.mian-list-info-right-tag {
    position: absolute;
    top:0;
    right: 0;
}

.mian-list-mark {
    border-top: 1px solid #e2e2e2;
    padding-top: 10px;
    font-size: 16px;
}

.mian-list-btns {
    margin-top: 20px;
    text-align: center;
}

.mian-list-btns button {
    margin-right: 10px;
    padding: 8px 20px;
    height: auto;
    border-radius: 34px;
    border: 0;
}

.mian-list-pic {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100px;
    height: 100px;
    transform: translate(0, -50%);
}

.mian-list-pic img {
    width: 100%;
    height: 100%;
}

.info {
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    margin: 20px 10px 10px 10px;
    font-size: 12px;
    width: 250px;
}

.mz-proof-btns {
    margin-bottom: 10px;
    text-align: center;
}

.mz-proof-btns button {
    margin-right: 10px;
    padding: 8px 20px;
    height: auto;
    border-radius: 34px;
    border: 0;
}

.mian-list-info-data-last {
    text-align: right;
}

.van-uploader__wrapper {
    width: 100%;
    display: block;
}

.van-uploader__upload {
    width: 100%;
}

.van-uploader {
    display: block;
}

.van-uploader__preview-image {
    width: 100%;
    height: 80px;
}

.pmain {
    background-color: white;
}

.pprice {
    position: relative;
    padding: 0px 10px;
}

.fl {
    font-size: 45px;
}

.fr {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 26px;
    font-weight: bold;
}

.ffbtns {
    text-align: right;
    padding: 0px 10px;
}

.ffbtns button {
    margin-right: 10px;
    padding: 5px 15px;
    border-radius: 4px;
    height: auto;
}
.zw{
    min-height: 12px;
}
</style>
